export { default } from "react-native-modal";
